module.exports = __webpack_public_path__ + "static/media/Fortis-Healthcare1.fd1a4f9a.webp";